import type { SlugBodyItem } from '~/components/slug/body';
import type { ImageProps } from '~/types';

export type ServicesRelaxCarouselSlide = {
  title: string;
  description: string;
  image: ImageProps;
};

export const services: SlugBodyItem[] = [
  {
    title: 'Finská sauna (suché teplo)',
    description: `<p>Teplota: 85–90 °C</p><br><p>Doba: Podle vašeho pocitu, následované ochlazením (sprcha, vědro, káď) a relaxací v odpočívárně s hudbou a nápoji. Celý proces opakujte aspoň 3x.</p><br><p>Čas pro sebe: Až 2 hodiny absolutního stišení a pohody.</p>`,
    image: {
      url: '/images/sauna/finska.webp',
      alt: 'Interiér dřevěné finské sauny',
    },
  },
  {
    title: 'Bio sauna s párou a bylinkami',
    description: `<p>Teplota: 70 °C</p><br><p>O co jde: Dýcháte příjemně vlhký vzduch s přídavkem bylinek podle vašeho výběru.</p><br><p>Čas pro sebe: Jemnější varianta saunování na celé 2 hodiny.</p>`,
    image: {
      url: '/images/sauna/bio.webp',
      alt: 'Bio sauna s bylinkovou párou',
    },
  },
  {
    title: 'Infrasauna (hloubkové prohřátí)',
    description: `<p>Doba: Max. 35 minut.</p><br><p>Účinky: Zmírňuje akné, ekzémy a celulitidu, podporuje tvorbu kolagenu a zrychluje metabolismus (pomáhá při hubnutí).</p><br><p>Náš tip: Infra sauna prohřeje svaly do hloubky. Nechte si po ní hned udělat masáž – její účinek bude mnohem hlubší a efektivnější!</p><br><p><u>Upozornění</u>: Infrasauna není vhodná pro těhotné ženy a osoby s prsními implantáty, kovovými náhradami či kardiostimulátory.</p>`,
    image: {
      url: '/images/sauna/infra.webp',
      alt: 'Infrasauna pro hloubkové prohřátí',
    },
  },
];
